import { useQuery } from "@tanstack/react-query";
import { WiMuleSQL } from "../services/WiMuleSQL";

export const useGetServiceTimes = (orderId) => {
  const fetchExtendedData = async ({ queryKey }) => {
    const [_, orderId] = queryKey;

    const response = await fetch(
      `${WiMuleSQL}/api/WiTool/GetServerServiceTimes?orderId=${orderId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    // Handle 204 No Content specifically
    if (response.status === 204) {
      // Return a default value or indicate no content in a way that suits your app
      return { message: "No Service Times recorded for this Order", data: [] };
    }

    if (!response.ok) {
      throw new Error(`HTTP Error: ${response.status}`);
    }

    return response.json();
  };

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["getServiceTimes", orderId],
    queryFn: fetchExtendedData,

    enabled: orderId !== undefined && orderId !== null,
  });

  return { data, isLoading, isError, error };
};
